module.exports = __webpack_public_path__ + "img/light-mud-decal-05.1eb30f29.png";